import React from "react";
import { Navigate, useParams } from "react-router";

import SingleEvent from "./SingleEvent";

import LoadingSpinner from "../../common/LoadingSpinner";

import { useAppSelector } from "../../redux/hooks";
import { getAuthToken } from "../../redux/reducers/auth";

import { getLargestImage } from "../../utils/GeneralUtils";
import { useMetaData } from "../../utils/useMetaData";
import { useGetEvents } from "../../utils/useEvent";
import OtherEventsContainer from "./OtherEventsContainer";

const SingleEventContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const auth_token = useAppSelector(getAuthToken);

  const {
    items: { events },
    isLoading,
  } = useGetEvents({ auth_token, id });
  const event = events[0];

  const genImgs = () => {
    const img: Array<string> = [];
    event.imgs?.map((image) => {
      const largest = getLargestImage(image);
      img.push(largest);
    });

    return img;
  };

  useMetaData(
    event
      ? {
          title: event.name,
          description: event.overview,
          imgUrl: event.imgs?.[0]?.medium?.url ?? "",
        }
      : undefined
  );

  if (isLoading) {
    return <LoadingSpinner space={1} />;
  } else if (event && event.id === id) {
    return (
      <SingleEvent
        type={event.event_type}
        name={event.name}
        start_date={event.start_date}
        end_date={event.end_date}
        start_time={event.start_time}
        end_time={event.end_time}
        location={event.location}
        img={genImgs()}
        game={event.game}
        media={event.media}
        address={event.address}
        direction={event.direction}
        map={event.map}
        relatedLink={event.relatedLinks}
        overview={event.overview}
        tags={event.tags}
        showJikeiBadge={
          event.role_restriction.includes("jikei_student") ? true : false
        }
        relatedContents={<OtherEventsContainer emitId={id} />}
      />
    );
  } else {
    return <Navigate to="/404" replace />;
  }
};

export default SingleEventContainer;
